module.exports = __webpack_public_path__ + "static/e-class-icon-742839cfdee50950f21b0c96d1c6a4e3.jpg";